<div class="layout__inner-card">
  @if (title) {
    <h3 class="text-center text-primary">{{ title }}</h3>
  }

  <p-divider><strong class="text-xl" i18n>Assurance de base</strong></p-divider>
  <div class="flex justify-content-between">
    <p
      >{{ baseInsurance.description | emTranslate }} : {{ baseInsurance.coverage | emAmount: 'noDecimal' }}</p
    >
    <p>{{ baseInsurance.price | emAmount }}</p>
  </div>

  @if (riders) {
    <p-divider i18n><strong class="text-xl">Avenants</strong></p-divider>
    @for (rider of riders; track rider) {
      <div class="flex justify-content-between">
        <p [class.line-through]="rider.isRemoved"
          >{{ rider.description | emTranslate }} : {{ rider.coverage | emAmount: 'noDecimal' }}</p
        >
        <p [class.line-through]="rider.isRemoved">{{ rider.price | emAmount }}</p>
      </div>
    }
  }

  <p-divider><strong class="text-xl">Total</strong></p-divider>
  <div class="flex justify-content-between">
    <p i18n>Prime mensuelle</p>
    @if (isUpdatingSurcharge) {
      <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="8"></p-progressSpinner>
    }
    @if (!isUpdatingSurcharge) {
      <h3 class="my-0">{{ totalPrice | emAmount }}</h3>
    }
  </div>
</div>
